import Header from "src/components/Header";
import { FooterContainer, FooterText, MainContainer } from "./styled";
import LoginFom from "src/components/LoginForm";

export default function LoginView({
  login,
}: {
  login: (username: string, password: string) => Promise<void>;
}) {
  return (
    <MainContainer>
      <Header />
      <LoginFom login={login} />
      <FooterContainer>
        <FooterText variant="body2" color={"neutral60.main"}>
          &copy; 2024 Big Health [Beta] Version 1.0
        </FooterText>
      </FooterContainer>
    </MainContainer>
  );
}
